import { LayoutType } from "app/area/reports/containers/chart/types-store";
import { ComplexValue } from "app/infrastructure/ui/form/types";

export const transformLayoutOptionsForSelect = (layoutTypes: LayoutType[]): ComplexValue<number>[] => {
  if(!layoutTypes?.length){
    return [];
  }
  return layoutTypes?.map((layoutType) => ({
    value: layoutType.type.v,
    description: layoutType.type.d
  }));
};
